__turbopack_context__.v({
  "className": "roboto_d2af2e36-module__1gdtkq__className",
  "variable": "roboto_d2af2e36-module__1gdtkq__variable",
});
